import React from 'react';
import AuthPageReader from '../AuthPageReader.jsx';

const RetailSignUpReader = (props) => <AuthPageReader {...props} domainType="RETAIL" pageKey="signUp" />;

export default RetailSignUpReader;
